/* ============================================================
   Exeskin — Bálsamo Piel Seca (slug 'exeskin'). Producto Shopify:
   "Bee venom crema veneno de abeja" (8574845681825).
   Cargado por layout/landing.liquid (case 'exeskin').
   Bloques: galería · selección de bundle (.ub-bundle) · stepper de cantidad ·
   disparo del modal Releasit COD.
   Patrón Releasit (per-unit + quantity): cada bundle = 1 variante con precio
   POR UNIDAD; mandamos quantity = unidades reales para que el pedido lleve las
   unidades exactas (Dropi) y el total quede correcto. El stepper MULTIPLICA la
   cantidad base del bundle (1 uds ó 3 uds del 2+1), así unit_price × qty siempre
   da el total correcto. Releasit lee input[name="quantity"] al disparar.
   NO usar _rsiV2.setState como primer path. Ver memory/project_bundles_as_variants.
   ============================================================ */

/* ---------- Galería: thumb cambia principal ---------- */
document.querySelectorAll('#thumbs .ub-thumb').forEach(function (t) {
  t.addEventListener('click', function () {
    document.querySelectorAll('#thumbs .ub-thumb').forEach(function (x) { x.classList.remove('active'); });
    t.classList.add('active');
    var img = t.querySelector('img');
    var main = document.getElementById('galMain');
    if (img && main) main.src = img.src;
  });
});

/* ============================================================
   Releasit COD trigger + selección de bundle + stepper
   ============================================================ */
var EXESKIN_RELEASIT_SELECTORS = [
  '#rsi_buy_now_button',
  '.rsi_buy_now_button',
  '._rsi-buy-now-button',
  '._rsi-buy-now-button-app-block-hook button',
  '._rsi-buy-now-button-app-block-hook a',
  '.rsi-btn-skel'
];

function exeskinFindReleasitButton() {
  for (var i = 0; i < EXESKIN_RELEASIT_SELECTORS.length; i++) {
    var el = document.querySelector(EXESKIN_RELEASIT_SELECTORS[i]);
    if (el) return el;
  }
  return null;
}

var exeskinSelectedVariantId = null;
var exeskinBaseQty = 1;    // unidades del bundle (1 ó 3)
var exeskinBaseTotal = 0;  // total del bundle en COP (para el display)
var exeskinStep = 1;       // multiplicador del stepper

function exeskinFmt(n) {
  return '$' + String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' COP';
}

function exeskinEffectiveQty() {
  var q = exeskinBaseQty * exeskinStep;
  return q < 1 ? 1 : q;
}

function exeskinSetVariantOnAllForms(variantId, qty) {
  if (!variantId) return;
  var q = parseInt(qty, 10);
  if (!q || q < 1) q = 1;
  document.querySelectorAll('form[action="/cart/add"] input[name="id"]').forEach(function (input) { input.value = variantId; });
  document.querySelectorAll('input[name="product-id"]').forEach(function (input) { input.value = variantId; });
  document.querySelectorAll('input[name="quantity"]').forEach(function (input) {
    input.value = String(q);
    input.setAttribute('value', String(q));
  });
  if (window.productData) { window.productData.quantity = q; }
  if (window.productData && Array.isArray(window.productData.variants)) {
    var v = window.productData.variants.find(function (x) { return String(x.id) === String(variantId); });
    if (v) {
      window.productData.selected_or_first_available_variant = v;
      window.productData.selected_variant = v;
      try {
        document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
        document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v } }));
      } catch (e) {}
    }
  }
}

function exeskinRefresh() {
  var priceEl = document.getElementById('mainPrice');
  if (priceEl && exeskinBaseTotal) priceEl.textContent = exeskinFmt(exeskinBaseTotal * exeskinStep);
  exeskinSetVariantOnAllForms(exeskinSelectedVariantId, exeskinEffectiveQty());
}

/* ---------- Selección de bundle ---------- */
document.querySelectorAll('.ub-bundle').forEach(function (b) {
  b.addEventListener('click', function () {
    document.querySelectorAll('.ub-bundle').forEach(function (x) { x.classList.remove('sel'); });
    b.classList.add('sel');
    var input = b.querySelector('input');
    if (input) input.checked = true;
    exeskinSelectedVariantId = b.getAttribute('data-bundle-variant-id');
    exeskinBaseQty = parseInt(b.getAttribute('data-bundle-qty'), 10) || 1;
    exeskinBaseTotal = parseInt(b.getAttribute('data-total'), 10) || 0;
    exeskinRefresh();
  });
});

/* ---------- Stepper de cantidad (multiplica el bundle) ---------- */
function qty(d) {
  exeskinStep = Math.max(1, exeskinStep + d);
  var el = document.getElementById('qtyVal');
  if (el) el.textContent = exeskinStep;
  exeskinRefresh();
}
window.qty = qty;

function exeskinTriggerCOD(btn) {
  if (exeskinSelectedVariantId) exeskinSetVariantOnAllForms(exeskinSelectedVariantId, exeskinEffectiveQty());
  setTimeout(function () {
    var releasitBtn = exeskinFindReleasitButton();
    if (releasitBtn) { releasitBtn.click(); return; }
    var attempts = 0;
    var poll = setInterval(function () {
      attempts++;
      var b = exeskinFindReleasitButton();
      if (b) { clearInterval(poll); b.click(); return; }
      if (attempts > 30) {
        clearInterval(poll);
        if (window._rsiV2 && typeof window._rsiV2.setState === 'function') {
          try { window._rsiV2.setState({ isOpen: true }); } catch (e) {}
        }
      }
    }, 100);
  }, 50);
}
window.exeskinTriggerCOD = exeskinTriggerCOD;

/* ---------- Review modal star picker ---------- */
var exeskinPicked = 5;
document.querySelectorAll('#starPick span').forEach(function (s) {
  s.addEventListener('click', function () {
    exeskinPicked = +s.dataset.v;
    document.querySelectorAll('#starPick span').forEach(function (x) { x.classList.toggle('on', +x.dataset.v <= exeskinPicked); });
  });
});
document.querySelectorAll('#starPick span').forEach(function (x) { x.classList.add('on'); });
function submitReview() {
  var name = (document.getElementById('revName') || {}).value || 'Anónimo';
  var text = (document.getElementById('revText') || {}).value || '';
  var car = document.querySelector('.ub-rev-carousel');
  if (!car) return;
  var card = document.createElement('div');
  card.className = 'ub-rev-card';
  card.innerHTML = '<div class="top"><span class="ub-stars">' + '★'.repeat(exeskinPicked) + '</span><span class="date">Ahora</span></div>' +
    '<div class="who"><b>' + name + '</b><span class="vf">Verificada</span></div>' +
    '<h4>Nueva reseña</h4><p>' + text + '</p>';
  car.prepend(card);
  var modal = document.getElementById('revModal');
  if (modal) modal.classList.remove('open');
}
window.submitReview = submitReview;

/* ---------- Init: bundle preseleccionado (.sel o el primero) ---------- */
(function () {
  var active = document.querySelector('.ub-bundle.sel') || document.querySelector('.ub-bundle');
  if (active) active.click();
})();
